import React, {useEffect, useState} from "react";
import styles from "../../assets/scss/v1/WeddingCard.module.scss"
import flowerLeft1 from "../../assets/images/v1/wedding-card/flowerLeft1.png";
import flowerLeft2 from "../../assets/images/v1/wedding-card/flowerLeft2.png";
import flowerRight1 from "../../assets/images/v1/wedding-card/flowerRight1.png";
import flowerRight2 from "../../assets/images/v1/wedding-card/flowerRight2.png";
import background from "../../assets/images/v1/wedding-card/background.png";
import CountDownTime from "../v0/CountDownTime";
import WeddingTimeLine from "./WeddingTimeLine";
import WeddingBook from "./WeddingBook";
import WeddingThankYou from "./WeddingThankYou";
import LoveStory from "../v0/LoveStory ";
import {useParams} from "react-router";
import WeddingService from "../../services/WeddingService";
import {WEDDING_HB} from "../../config";
import RecordPlayer from "./RecordPlayer";
import JumpingText from "../../hooks/JumpingText";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";

const WeddingCard = () => {

    const {userId} = useParams();

    const [inviteInfo, setInviteInfo] = useState({});

    const [linkMaps, setLinkMaps] = useState("https://maps.app.goo.gl/TVxLtmBJRAMxX6u67");

    useEffect(() => {
        if (userId) {
            WeddingService.getUserNameByUserId(userId)
                .then(response => {
                    if (200 === response.status && response.data) {
                        if (Array.isArray(response.data) && response.data.length > 0)
                            setInviteInfo(response.data[0]);
                        if (WEDDING_HB == response.data[0].unit) {
                            setLinkMaps("https://maps.app.goo.gl/VY6YE5ebe5tfWXBB8")
                        } else {
                            setLinkMaps("https://maps.app.goo.gl/TVxLtmBJRAMxX6u67")
                        }
                    }
                })
        }

    }, [userId])

    return (
        <>
            <div className={styles.weddingCard}>
                <div className={styles.flowerLeft1}>
                    <img src={flowerLeft1} alt={'flowerLeft1'}/>
                </div>

                <div className={styles.flowerLeft2}>
                    <img src={flowerLeft2} alt={'flowerLeft2'}/>
                </div>

                <div className={styles.flowerLeft4}>
                    <img src={flowerLeft1} alt={'flowerLeft4'}/>
                </div>

                <div className={styles.container}>
                    <div className={styles.title}>
                        <div className={styles.saveTheDate}>Save The Date</div>
                        <div className={styles.dateWedding}>23.03.2025</div>
                    </div>
                    <div className={styles.content}>
                        <div className={styles.nameWedding}>
                            <div className={styles.husbandName}>
                                BẠCH HẢI
                            </div>
                            <div className={styles.andText}>
                                and
                            </div>
                            <div className={styles.wifeName}>
                                MINH GIANG
                            </div>
                        </div>
                        <div className={styles.inviteSection}>
                            <div style={{display: 'flex', alignItems: 'center'}}>Trân trọng kính mời: <span
                                className={styles.inviteName}>{inviteInfo?.desc ? inviteInfo?.desc : 'Anh chị'}</span>
                            </div>
                            <div style={{fontWeight: '400', fontStyle: 'italic'}}>Đến dự bữa cơm thân mật cùng gia đình
                                chúng tôi tại
                            </div>
                        </div>

                        <RecordPlayer/>

                        <div className={styles.dateWeddingInfoSection}>
                            <div className={styles.datePartySection}>
                                <div className={styles.month}>Tháng 03</div>
                                <div className={styles.date}>22</div>
                                <div className={styles.year}>2025</div>
                            </div>

                            <div className={styles.placePartySection}>
                                <div className={styles.placeTitle}>TƯ GIA
                                    NHÀ {WEDDING_HB == inviteInfo?.unit ? 'TRAI' : 'GÁI'}</div>
                                <div
                                    className={styles.placeWard}>{WEDDING_HB == inviteInfo?.unit ? 'Thôn Ngô Cương, Xã Nhân Thắng' : 'Thôn Đìa, Xã Bình Dương'}</div>
                                <div className={styles.placeCity}>Huyện Gia Bình, Tỉnh Bắc Ninh</div>
                                <div className={styles.mapSection}>
                                    <a href={linkMaps} target="_blank" rel="noopener noreferrer"
                                       className={styles.actionButton}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-around',
                                            width: '100%'
                                        }}><FontAwesomeIcon icon={faMapMarkerAlt}/>
                                            <div style={{position: 'relative', top: '-2px'}}>Chỉ đường</div>
                                        </div>
                                    </a>
                                </div>
                            </div>


                        </div>
                        <div className={styles.lunerDate}>(Tức Ngày 23 Tháng 02 Năm Ất Tỵ)</div>
                        <div className={styles.countDownTimeSection}>
                            <CountDownTime/>
                        </div>
                        <div className={styles.thankYouInfoSection}>
                            <div className={styles.thankYouInfoContainer}>
                                <div className={styles.thankYouContent}>
                                    <div className={styles.thankYouTitle}>
                                        <div className={styles.title1}>Ngày</div>
                                        <div className={styles.title2}>Chung</div>
                                        <div className={styles.title3}>Đôi</div>
                                    </div>
                                    <div className={styles.thankYouMessage}>
                                        <div className={styles.messageTime}>
                                            <div className={styles.time}>
                                                11h15
                                            </div>
                                            <div className={styles.messageTimeContent}>
                                                Lễ Vu Quy được tổ chức tại <br/> Tư gia nhà gái
                                            </div>
                                            <div className={styles.messageTimeContent}>
                                                Thôn Đìa, Xã Bình Dương <br/> Huyện Gia Bình, Tỉnh Bắc Ninh
                                            </div>

                                            <div className={styles.time}>
                                                12h00
                                            </div>
                                            <div className={styles.messageTimeContent}>
                                                Lễ Thành Hôn được tổ chức tại <br/> Tư gia nhà trai
                                            </div>
                                            <div className={styles.messageTimeContent}>
                                                Thôn Ngô Cương, Xã Nhân Thắng <br/> Huyện Gia Bình, Tỉnh Bắc Ninh
                                            </div>
                                        </div>
                                        <div className={styles.messageDate}>
                                            <div>.23</div>
                                            <div>.03</div>
                                            <div>.25</div>
                                        </div>
                                    </div>
                                    <div className={styles.homeSection}>

                                        <div>
                                            <div className={styles.homeWife}>Nhà gái</div>
                                            Ông Vũ Văn Tô <br/> Bà Lê Thị Huệ
                                        </div>
                                        <br/>
                                        <div className={styles.homeHusbandSection}>
                                            <div className={styles.homeHusband}>Nhà trai</div>
                                            Ông Bạch Văn Hoàn <br/> Bà Lê Thị Phương
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <WeddingTimeLine/>
                        <LoveStory/>
                        <WeddingBook/>
                        <WeddingThankYou/>
                    </div>

                </div>

                <div className={styles.flowerRight1}>
                    <img src={flowerRight1} alt={'flowerRight1'}/>
                </div>

                <div className={styles.flowerRight2}>
                    <img src={flowerRight2} alt={'flowerRight21'} className={styles.flowerRight21}/>
                    <img src={flowerRight1} alt={'flowerRight12'} className={styles.flowerRight22}/>
                </div>

                <div className={styles.flowerLeft3}>
                    <img src={flowerLeft1} alt={'flowerLeft3'}/>
                </div>
            </div>
        </>
    )
}

export default WeddingCard;